import React from "react";

const SliderPrevIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g opacity="0.4">
        <path
          d="M30.8203 33.16L21.6603 24L30.8203 14.82L28.0003 12L16.0003 24L28.0003 36L30.8203 33.16Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export default SliderPrevIcon;
